module.exports = {"meta":"Links","immediate-aid-title":"Soforthilfe","pension-title":"Vorsorge und Erbrecht","advance-decision-title":"Patientenverfügung"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/links.json
// module id = ZacK
// module chunks = 1